module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageInstructionDomain":"Instructions for connecting the domain"}}')
  delete Component.options._Ctor
}
